module.exports = __webpack_public_path__ + "img/zabranie.e0ed19a4.svg";